enum RecordingGroupCategory {
    Pending = 'pending',
    Accepted = 'accepted',
    Rejected = 'rejected',
}

export default RecordingGroupCategory
